// extracted by mini-css-extract-plugin
module.exports = {"item":"ContactListItem_item__1wns_","btn":"ContactListItem_btn__ZQTUQ"};